// import libraries
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
// import component
import Layout from "../../layouts/Layout";
import Pagination from "../../components/Common/Table/Pagination";
import SortData from "../../components/Common/Table/SortData";
import SearchBar from "../../components/Common/Table/SearchBar";
import LoaderIcon from "../../components/Common/Icon/Loader";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
import MonthDropDown from "../../components/Common/InputField/MonthDropDown";
import PaymentMethodCheckbox from "../../components/Common/InputField/PaymentMethodCheckbox";
import TableLoaderIcon from "../../components/Common/Icon/TableLoader";
import MobilePagination from "../../components/Common/Table/MobilePagination";
// import files
import { env } from "../../env";
import { logEvent } from "../../analytics";

const CustomerProfileIndex = () => {
    // variables
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const dropdownRef1 = useRef(null);
    const [isLoader, setIsLoader] = useState(true);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showSort, setShowSort] = useState(false);
    const [showState, setShowState] = useState(false);
    const [showCity, setShowCity] = useState(false);
    const [rowCurrentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState("c.\"Name\"");
    const [sortOrder, setSortOrder] = useState("");
    const [sortName, setSortName] = useState("");
    const [customers, setCustomers] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [sortTypesList, setSortTypesList] = useState([
        {
            "name" : "customer name - top to bottom",
            "field" : 'c.\"Name\"',
            "type" : "asc"
        },
        {
            "name" : "customer name - bottom to top",
            "field" : 'c.\"Name\"',
            "type" : "desc"
        },
        {
            "name" : "email - top to bottom",
            "field" : 'c.\"Email\"',
            "type" : "asc"
        },
        {
            "name" : "email - bottom to top",
            "field" : 'c.\"Email\"',
            "type" : "desc"
        },
        {
            "name" : "create date - top to bottom",
            "field" : "date",
            "type" : "asc"
        },
        {
            "name" : "create date - bottom to top",
            "field" : "date",
            "type" : "desc"
        },
        {
            "name" : "address - top to bottom",
            "field" : 'c.\"Address\"',
            "type" : "asc"
        },
        {
            "name" : "address - bottom to top",
            "field" : 'c.\"Address\"',
            "type" : "desc"
        },
        {
            "name" : "payment - top to bottom",
            "field" : 'pt.\"title\"',
            "type" : "asc"
        },
        {
            "name" : "payment - bottom to top",
            "field" : 'pt.\"title\"',
            "type" : "desc"
        }
    ]);
    const [paymentMethodList, setPaymentMethodList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [filterInputs, setFilterInputs] = useState({
        month: "",
        createmonth: "",
        state: "",
        city: "",
        method: "",
    });

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowSort(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setShowFilter(false);
                setShowState(false);
                setShowCity(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // functions
    useEffect(() => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        axios.get(baseUrl+"/api/OfflineSync/GetPaymentTypeList", { headers })
        .then((response) => {
            setPaymentMethodList(response.data);
        }).catch((error) => {
            console.log(error);
        });

        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            state_info: filterInputs.state,
            city_info: filterInputs.city,
            payment_info: filterInputs.method,
            customer_type_id: "",
            prospect_customer: ""
        }
        customerDataApi(requestData);
        getStateListApi(baseUrl, token);
        getCityListApi(baseUrl, token);
        clearCartStorage();
    }, []);

    const clearCartStorage = () => {
        localStorage.removeItem('co_tab');
        localStorage.removeItem('co_coupon');
        localStorage.removeItem('co_comment');
        localStorage.removeItem('co_method');
        localStorage.removeItem('co_id');
        localStorage.removeItem('co_quantity');
        localStorage.removeItem('co_qty_message');
        localStorage.removeItem('co_items');
        localStorage.removeItem('co_calculate');
        localStorage.removeItem('co_code');
        localStorage.removeItem('co_calculate_json');
        localStorage.removeItem('co_calculate_button');
        localStorage.removeItem('co_calculate_filter');
        localStorage.removeItem('transaction-date-filter');
        localStorage.removeItem("co_customer");
    };
    const customerDataApi = async (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(baseUrl+"/api/Customer/GetCustomerDetailSearch", data, {headers}).then((response) => {
            if(response.status === 200) {
                const location = [];
                if(!response.data.success) {
                    setCustomers(response.data);
                }
                setIsLoader(false);
                setIsTableLoader(false);
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getStateListApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/Customer/GetCustomersState", {headers})
        .then((response) => {
            setStateList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCityListApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/Customer/GetCustomersCity", {headers})
        .then((response) => {
            setCityList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleCurrentPage = (page) => {
        setIsTableLoader(true);
        setCustomers({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(page);
        const requestData = {
            page_num : page,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            state_info: filterInputs.state,
            city_info: filterInputs.city,
            payment_info: filterInputs.method,
            customer_type_id: "",
            prospect_customer: ""
        }
        logEvent('customer_list_page', 'order', 'pagination', page);
        customerDataApi(requestData);
    };
    const handlePerPage = (row) => {
        setIsTableLoader(true);
        setCustomers({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setRowsPerPage(row);
        const requestData = {
            page_num : 1,
            page_size : row,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            state_info: filterInputs.state,
            city_info: filterInputs.city,
            payment_info: filterInputs.method,
            customer_type_id: "",
            prospect_customer: ""
        }
        logEvent('customer_list_page', 'order', 'pagination_per_page', row);
        customerDataApi(requestData);
    };
    const handleShowSort = (e) => {
        e.preventDefault();
        setShowSort(!showSort); 
        setShowFilter(false);
    };
    const handleShowFilter = (e) => {
        setShowFilter(!showFilter); 
        setShowSort(false); 
    };
    const handleSearchDataFromChild = (data) => {
        setIsTableLoader(true);
        setCustomers({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setSearchTerm(data);
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : data,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            state_info: filterInputs.state,
            city_info: filterInputs.city,
            payment_info: filterInputs.method,
            customer_type_id: "",
            prospect_customer: ""
        }
        logEvent('customer_list_page', 'order', 'search', data);
        customerDataApi(requestData);
    };
    const handleSortDataFromChild = (data) => {
        setSortBy(data.field);
        setSortOrder(data.type);
        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : data.field,
            sort_order : data.type,
            month_info: filterInputs.createmonth,
            state_info: filterInputs.state,
            city_info: filterInputs.city,
            payment_info: filterInputs.method,
            customer_type_id: "",
            prospect_customer: ""
        }
        logEvent('customer_list_page', 'order', 'sort', data);
        customerDataApi(requestData);
    };
    const handleSortTypeDataFromChild = (e, data) => {
        e.preventDefault();
        setShowSort(!showSort); 
        setSortBy(data.field);
        setSortOrder(data.type);
        setSortName(data.name);
        setCurrentPage(1);

        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : data.field,
            sort_order : data.type,
            month_info: filterInputs.createmonth,
            state_info: filterInputs.state,
            city_info: filterInputs.city,
            payment_info: filterInputs.method,
            customer_type_id: "",
            prospect_customer: ""
        }
        logEvent('customer_list_page', 'order', 'sort', data);
        customerDataApi(requestData);
    };
    const handleMonthDataFromChild = (data) => {
        if(data) {
            setFilterInputs({
                ...filterInputs,
                'month' : data.name,
                'createmonth' : data.id 
            });
        } else {
            setFilterInputs({
                ...filterInputs,
                'month' : "",
                'createmonth' : ""
            });
        }
    };
    const handleMethodDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            'method' : data.toString()
        });
    };
    const clearData = (e) => {
        e.preventDefault();
        setIsTableLoader(true);
        setCustomers({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setFilterInputs({
            ...filterInputs,
            'month': "",
            'createmonth': "",
            'state': "",
            'city': "",
            'method': "",
        });
        
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: "",
            state_info: "",
            city_info: "",
            payment_info: "",
            customer_type_id: "",
            prospect_customer: ""
        }
        logEvent('customer_list_page', 'order', 'filter', 'clear-filter');
        customerDataApi(requestData);
        setShowFilter(!showFilter);
    };
    const handleState = (e, value) => {
        setShowState(!showState);
        setFilterInputs({
            ...filterInputs,
            ['state']: value
        });
    };
    const handleCity = (e, value) => {
        setShowCity(!showCity);
        setFilterInputs({
            ...filterInputs,
            ['city']: value
        });
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setIsTableLoader(true);
        setCustomers({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            state_info: filterInputs.state,
            city_info: filterInputs.city,
            payment_info: filterInputs.method,
            customer_type_id: "",
            prospect_customer: ""
        }
        logEvent('customer_list_page', 'order', 'filter', requestData);
        customerDataApi(requestData);
        setShowFilter(!showFilter);
    };
    const handleLog = (id) => {
        logEvent('customer_list_page', 'order', 'redirect_to_create_order', id);
    }
    const handleRedirect = (data) => {
        navigate(`/customers/detail/${data}`)
    };

    return (
        <Layout>
            {/* first box */}
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="sm:text-2xl font-semibold capitalize">{ t('customer profile') }</h1>
                    <p className="text-light-400 text-xs sm:text-sm capitalize">{ t('profile') } / { t('customer profile') }</p>
                </div>
            </div>
            { isLoader
            ?
                <LoaderIcon />
            :
                <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4 shadow-around">
                    {/* search and filter */}
                    <div className="sm:flex sm:justify-between sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                        <SearchBar placeholder={t("search")+"..."} term={searchTerm} setSearchDataFromChild={handleSearchDataFromChild}/>
                        <div className="flex items-center justify-end space-x-2">
                            <div ref={dropdownRef} className="relative"> 
                                <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e)}>
                                    <img className="w-6 h-6" src="../../../assets/icons/table/sort.svg" alt="sort" />
                                </div>
                                {
                                    showSort
                                    ?
                                        <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-56 text-left h-40 overflow-y-auto no-scrollbar">
                                            {sortTypesList.map((value, index) => (
                                                <li key={index} onClick={(e) => handleSortTypeDataFromChild(e, value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                            ))}
                                        </ul>
                                    : null
                                }
                            </div>
                            <div ref={dropdownRef1} className="relative">
                                <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e)}>
                                    <div>
                                        <img className="w-3.5 sm:w-4" src="../../assets/icons/table/filter.svg" alt="filter" />
                                    </div>
                                    <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                </div>
                                {
                                    showFilter 
                                    ?
                                        <FilterFormLayout>
                                            <form onSubmit={handleFilterSubmit}>
                                                <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                    <MonthDropDown monthValue={filterInputs.month} sendMonthDataFromChild={handleMonthDataFromChild} />
                                                    <div>
                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('state')}</label>
                                                        <div className="inline-block relative w-full mt-1">
                                                            <button type="button" onClick={(e) => setShowState(!showState)} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base px-3 py-2 rounded-md inline-flex items-center">
                                                                <span className={filterInputs.state.length > 0 ? "text-black" : "text-gray-dark" + " mr-1 text-xs sm:text-base"}>{filterInputs.state.length > 0 ? filterInputs.state : t('select state')}</span>
                                                                <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                                            </button>
                                                            {
                                                                showState
                                                                ? 
                                                                    <ul className="absolute w-full h-52 overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md">
                                                                        <li key="" onClick={(e) => handleState((e), '')} className="cursor-pointer bg-white hover:bg-action-hover px-3 py-2 block whitespace-no-wrap capitalize text-xs sm:text-base">{ t('select state')}</li>
                                                                        { stateList.map((state, index) => (
                                                                            <li key={'state'+index} onClick={(e) => handleState((e), state)} className="bg-white hover:bg-action-hover cursor-pointer py-2 px-4 block whitespace-no-wrap text-xs sm:text-base">{state}</li>
                                                                        ))}
                                                                    </ul>                            
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('city/town')}</label>
                                                        <div className="mt-1 inline-block relative w-full">
                                                            <button type="button" onClick={(e) => setShowCity(!showCity)} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base px-3 py-2 rounded-md inline-flex items-center">
                                                                <span className={filterInputs.city.length > 0 ? "text-black" : "text-gray-dark" + " mr-1 text-xs sm:text-base"}>{filterInputs.city.length > 0 ? filterInputs.city :  t('select city')}</span>
                                                                <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                                            </button>
                                                            {
                                                                showCity
                                                                ? 
                                                                    <ul className="absolute w-full h-52 overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md">
                                                                        <li key="" onClick={(e) => handleCity((e), '')} className="cursor-pointer bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap capitalize text-xs sm:text-base">{ t('select city')}</li>
                                                                        { cityList.map((city, index) => (
                                                                            <li key={'city'+index} onClick={(e) => handleCity((e), city)} className="cursor-pointer bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap text-xs sm:text-base">{city}</li>
                                                                        ))}
                                                                    </ul>                            
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                    <PaymentMethodCheckbox parentData={filterInputs.method} paymentMethodList={paymentMethodList} sendMethodDataFromChild={handleMethodDataFromChild}/>
                                                    <div className="flex items-center justify-end my-2">
                                                        <div>
                                                            <button onClick={(e) => clearData(e)} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                        </div>
                                                        <div className="ml-4">
                                                            <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </FilterFormLayout>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                    {/* table with pagination*/}
                    <div className="sm:block hidden mt-4 relative overflow-x-auto shadow-md rounded-lg">
                        <table className="w-full text-xs">
                            <thead className="text-gray-normal bg-background-normal">
                                <tr>
                                    <th scope="col" className="font-normal p-4 w-[20%]">
                                        <div className="flex">
                                            <div className="mr-2 uppercase">
                                                { t('customer name')}
                                            </div>
                                            <SortData fieldName={'c.\"Name\"'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                        </div>
                                    </th>
                                    <th scope="col" className="font-normal p-4 w-[15%]">
                                        <div className="flex">
                                            <div className="mr-2 uppercase">
                                                { t('email address') }
                                            </div>
                                            <SortData fieldName={'c.\"Email\"'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                        </div>
                                    </th>
                                    <th scope="col" className="font-normal p-4 w-[15%]">
                                        <div className="flex">
                                            <div className="mr-2 uppercase">
                                                { t('create date') }
                                            </div>
                                            <SortData fieldName={'date'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                        </div>
                                    </th>
                                    <th scope="col" className="font-normal p-4 w-[25%]">
                                        <div className="flex">
                                            <div className="mr-2 uppercase">
                                                { t('address') }
                                            </div>
                                            <SortData fieldName={'c.\"Address\"'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                        </div>
                                    </th>
                                    <th scope="col" className="font-normal p-4 w-[10%]">
                                        <div className="flex">
                                            <div className="mr-2 uppercase">
                                                { t('payment') }
                                            </div>
                                            <SortData fieldName={'pt.\"title\"'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    customers.list.length > 0 ?
                                        (customers.list).map((row, index) => (
                                            <tr onClick={(e) => handleRedirect(row.id)} key={`customer`+row.id} className="bg-white border-b hover:bg-gray-50 cursor-pointer py-2">
                                                <td className="p-4 font-semibold">
                                                    {row.name}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.email ? row.email : 'NA'}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.createdate ? moment(row.createdate, "DD-MM-YYYY hh:mm:ss").format("DD/MM/YYYY") : 'NA'}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.address}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.paymenttype ? row.paymenttype : 'NA'}
                                                </td>
                                            </tr>
                                        ))
                                    : null
                                }
                            </tbody>                            
                        </table>
                        { isTableLoader
                            ?
                                <TableLoaderIcon />
                            : (
                                customers.list.length > 0 
                                ?
                                    <Pagination
                                        currentPage={rowCurrentPage}
                                        totalCount={customers.total_record}
                                        pageSize={rowsPerPage}
                                        perPageCount={customers.list.length}
                                        onPageChange={page => handleCurrentPage(page)}
                                        onPageSizeChange={row => handlePerPage(row)}
                                    />
                                : 
                                    <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                            { t('no data available')}
                                    </div>
                            )
                        }
                    </div>
                    <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                        {(customers.list.length > 0) ?
                            <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                { customers.list.map((row, index) => (
                                    <div key={'order'+row.id} onClick={(e) => handleRedirect(row.id)} className=" border border-action-hover bg-action-hover rounded-[10px] p-2 space-y-2">
                                        <div className="space-y-2">
                                            <div className="space-y-1">
                                                <div className="font-medium text-base">{row.name ? row.name : 'NA'}</div>
                                                <div className="text-light-400 text-xs grid grid-cols-3 gap-0.5">
                                                    <div className="capitalize">{ t('email')}</div><div className="font-medium col-span-2 break-all">{row.email ? row.email : '--'}</div>
                                                </div>
                                                <div className="text-light-400 text-xs grid grid-cols-3 gap-0.5">
                                                    <div className="capitalize">{ t('address')}</div><div className="font-medium col-span-2 break-all">{row.address ? row.address : '--'}</div>
                                                </div>
                                                <div className="text-light-400 text-xs grid grid-cols-3 gap-0.5">
                                                    <div className="capitalize">{ t('create date')}</div><div className="font-medium col-span-2">{row.createdate ? moment(row.createdate, "DD-MM-YYYY hh:mm:ss").format("DD/MM/YYYY") : '--'}</div>
                                                </div>
                                                <div className="text-light-400 text-xs grid grid-cols-3 gap-0.5">
                                                    <div className="capitalize">{ t('payment')}</div><div className="font-medium col-span-2">{row.paymenttype ? row.paymenttype : '--'}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            : null
                        }
                        { isTableLoader
                            ?
                                <TableLoaderIcon />
                            : (
                                customers.list.length > 0 
                                ?
                                    <MobilePagination
                                        currentPage={rowCurrentPage}
                                        totalCount={customers.total_record}
                                        pageSize={rowsPerPage}
                                        perPageCount={customers.list.length}
                                        onPageChange={page => handleCurrentPage(page)}
                                        onPageSizeChange={row => handlePerPage(row)}
                                    />
                                : 
                                    <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                        { t('no data available')}
                                    </div>
                            )
                        }
                    </div>
                </div>
            }
        </Layout>
    )
}

export default CustomerProfileIndex;